import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { WeekOfYear } from '../../../domain/models';
import { DistributionListItemViewModel } from '../../view-models/distribution-list-item.view-model';
import { FilterDistributions, LoadDistributions, LoadWeeks, SelectDistribution, SetActiveWeek, SetMapExpansion } from '../../store/distribution.actions';
import { getActiveWeek, getDistributions, getWeeks } from '../../store/distribution.reducer';
import { DistributionState } from '../../store/distribution.state';

@Component({
    selector: 'app-list-container',
    template: `<app-list
        [activeWeek]="activeWeek$ | async"
        [items]="distributions$ | async"
        [weeks]="weeks$ | async"
        (onDetailClick)="showDetail($event)"
        (onRowClick)="zoomToItem($event)"
        (onWeekChange)="updateList($event)"
        (onDistributionsFilter)="updatePolygonsRendering($event)">
    </app-list>`,
})
export class ListContainerComponent implements OnInit {

    activeWeek$: Observable<WeekOfYear>;
    distributions$: Observable<DistributionListItemViewModel[]>;
    weeks$: Observable<WeekOfYear[]>;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private store: Store<DistributionState>,
    ) {
        this.activeWeek$ = store.pipe(select(getActiveWeek));
        this.distributions$ = store.pipe(select(getDistributions));
        this.weeks$ = store.pipe(select(getWeeks));
    }

    ngOnInit(): void {
        this.store.dispatch(new SetMapExpansion(false));
        this.store.dispatch(new LoadWeeks());
        this.route.queryParams.subscribe((queryParams: Params) => {
            if (queryParams.week) {
                this.store.dispatch(new LoadDistributions(parseInt(queryParams.week, 10)));
            }
        });
    }

    showDetail(distribution: DistributionListItemViewModel): void {
        this.router.navigate([distribution.distributionId], { relativeTo: this.route });
    }

    updateList(week: WeekOfYear): void {
        this.store.dispatch(new SetActiveWeek(week.weekNumber));
    }

    zoomToItem(distribution: DistributionListItemViewModel): void {
        this.store.dispatch(new SelectDistribution(null));
        setTimeout(() => {
            this.store.dispatch(new SelectDistribution(distribution));
        });
    }

    updatePolygonsRendering(sectorIds: string[]): void {
        this.store.dispatch(new FilterDistributions(sectorIds));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/containers/list-container/list-container.component.ts